import { useEffect, useState, MouseEvent } from 'react'
import { BackButton, Breadcrums } from '../../Shared'
import HeaderComponent from '../../Atoms/HeaderComponent'
import CONSTANTS, { BREADCRUMS, PAGES_ROUTES } from '../../../Constants'
import styles from '../../ManageWidget/ManageWidget.module.scss'
import { useParams, useNavigate } from 'react-router-dom'
import {
  combineErrorMessage,
  getDateInFormat,
  getHeaderData,
  getPageName,
  handleResponse,
  toCamelCase,
} from '../../../Helpers/Util'
import { useAppDispatch } from '../../../Store/Hooks'
import { getWidgetDetailById } from '../../../Store/Slice/manage-widget.slice'
import {
  getContainerDetailById,
  setParentContainerDetail,
} from '../../../Store/Slice/manage-container.slice'
import { getDetailById } from '../../../Store/Slice/site-navigation.slice'
import { IKeyValue } from '../../../Models/CommonListHeadingModal'
import ListingComponent from '../ListingComponent'
import { Tablecolumn } from '../../../Models'
import mainApiService from '../../../Services'
import AssetStateLabel from '../../Labels/AssetStateLabel'
import { showAlert } from '../../../Store/Slice/alert.slice'
import {
  ASSOCIATED_LIST,
  CONTAINER_MANAGEMENT_CRUD,
  SITE_NAVIGATION_CRUD,
  WIDGET_MANAGEMENT_CRUD,
} from '../../../Constants/ApiDefinations'
import { getMasterByKey } from '../../../Store/Slice/system-configuration.slice'
import { ASSOCIATED_ITEMS, MODULE_CONSTANTS } from '../../../Constants/Texts'
import { viewSegmentService } from '../../../Store/Slice/segment.slice'
import { viewParameterService } from '../../../Store/Slice/parameter.slice'
import { Typography } from '@mui/material'
import style from './AssociatedItems.module.scss'

interface ListingData {
  redirectViewAPiRouteMidPoint: string
  entityType: string
  displayName: string
}

const getTabConfig = (tabKey: string, isParamRepo: boolean) => {
  const tabConfigs: Record<string, any> = {
    container: {
      columns: isParamRepo
        ? CONSTANTS.ASSOCIATED_PARAMETER_REPOSITORY_LISTING_COLUMNS_FOR_CONTAINER
        : CONSTANTS.ASSOCIATED_CONTAINER_LISTING_COLUMNS,
      listDetail: {
        redirectViewAPiRouteMidPoint: isParamRepo
          ? `${PAGES_ROUTES.BoltMaster}/${PAGES_ROUTES.ContainerDefinitionList}`
          : PAGES_ROUTES.ManageContainer,
        entityType: 'container',
        displayName: 'container',
      },
    },
    widget: {
      columns: isParamRepo
        ? CONSTANTS.ASSOCIATED_PARAMETER_REPOSITORY_LISTING_COLUMNS
        : CONSTANTS.ASSOCIATED_WIDGET_LISTING_COLUMNS,
      listDetail: {
        redirectViewAPiRouteMidPoint: isParamRepo
          ? `${PAGES_ROUTES.BoltMaster}/${PAGES_ROUTES.WidgetDefinitionList}`
          : PAGES_ROUTES.ManageWidget,
        entityType: 'widget',
        displayName: 'widget',
      },
    },
    siteNavigation: {
      columns: isParamRepo
        ? CONSTANTS.ASSOCIATED_PARAMETER_REPOSITORY_LISTING_COLUMNS
        : CONSTANTS.ASSOCIATED_SITE_NAVIGATION_LISTING_COLUMNS,
      listDetail: {
        redirectViewAPiRouteMidPoint: isParamRepo
          ? `${PAGES_ROUTES.BoltMaster}/${PAGES_ROUTES.WidgetDefinitionList}`
          : PAGES_ROUTES.SiteNavigation,
        entityType: 'siteNavigation',
        displayName: 'site navigation',
      },
    },
  }
  return tabConfigs[tabKey]
}

const AssociatedItems = () => {
  const { module, id } = useParams()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [detailData, setDetailData] = useState<any>({})
  const [selectedTabs, setSelectedTabs] = useState({ key: '', value: '' })
  const [tabs, setTabs] = useState<IKeyValue[]>([])
  const [columnData, setColumnData] = useState<Tablecolumn[]>([])
  const [listData, setListData] = useState<any[]>([])
  const [dataCount, setDataCount] = useState(0)
  const [listingProperty, setListingProperty] = useState<ListingData>({
    redirectViewAPiRouteMidPoint: '',
    entityType: '',
    displayName: '',
  })
  const [headerLabel, setHeaderLabel] = useState('')
  const [clearColumnFilter, setClearColumnFilter] = useState<boolean>(false)
  const [listFilter, setListFilter] = useState<any>([])
  const [isLoader, setIsLoader] = useState<boolean>(true)
  const [listingApiCall, setListingApiCall] = useState(false)
  const [searchFunctionFilters, setSearchFunctionFilters] = useState<{
    sortBy: string | number
    filterValue: string
    sortType: number
    page: number
    limit: number
    filters: any
  }>({ sortBy: '', filterValue: '', sortType: 0, page: 1, limit: 10, filters: [] })

  useEffect(() => {
    getDetailDataAccToModule()
  }, [])

  useEffect(() => {
    if (tabs.length > 0) {
      setSelectedTabs(tabs[0])
    }
  }, [tabs])

  useEffect(() => {
    if (detailData?.segmentName) {
      document.title = `Associated Items - ${detailData.segmentName}`
      return
    }
    if (detailData?.parameterName) {
      document.title = `Associated Items - ${detailData.parameterName}`
      return
    }
    if (detailData?.title && detailData.title !== 'NA') {
      document.title = `Associated Items - ${detailData.title}`
      return
    }
    document.title = 'Associated Items'
  }, [detailData?.segmentName, detailData?.parameterName, detailData?.title])

  useEffect(() => {
    const selectedTabsKey = selectedTabs.key
    if (selectedTabsKey) {
      getLayoutAndState()
      setListData([])
      const config = getTabConfig(selectedTabsKey, module === 'parameter-repository')
      if (config) {
        setColumnData(config.columns)
        setListingProperty(config.listDetail)
      }
      setClearColumnFilter(true)
      setListingApiCall(true)
    }
  }, [selectedTabs])

  const getDetailDataAccToModule = async () => {
    if (module && id) {
      let listDetail: any
      let result: any
      switch (module) {
        case CONSTANTS.ASSOCIATED_MODULE_WIDGET:
          result = await dispatch(getWidgetDetailById(id) as any)
          setTabs(ASSOCIATED_ITEMS.ASSOCIATED_TABS)
          setHeaderLabel('Widget')
          listDetail = {
            redirectViewAPiRouteMidPoint: PAGES_ROUTES.ManageContainer,
            entityType: 'container',
            displayName: 'container',
          }
          break
        case CONSTANTS.ASSOCIATED_MODULE_SEGMENT:
          result = await dispatch(viewSegmentService(id) as any)
          setTabs(ASSOCIATED_ITEMS.ASSOCIATED_TABS)
          setHeaderLabel('Segment')
          listDetail = {
            redirectViewAPiRouteMidPoint: PAGES_ROUTES.ManageContainer,
            entityType: 'container',
            displayName: 'container',
          }
          break
        case CONSTANTS.ASSOCIATED_MODULE_PARAMETER_REPOSITORY:
          result = await dispatch(viewParameterService(id) as any)

          setTabs(ASSOCIATED_ITEMS.ASSOCIATED_TABS)
          setHeaderLabel('Parameter')
          listDetail = {
            redirectViewAPiRouteMidPoint: `${PAGES_ROUTES.BoltMaster}/${PAGES_ROUTES.ContainerDefinitionList}`,
            entityType: 'container',
            displayName: 'container',
          }
          break
        case CONSTANTS.ASSOCIATED_MODULE_SITENAVIGATION:
          result = await dispatch(getDetailById(id) as any)
          setTabs(
            ASSOCIATED_ITEMS.ASSOCIATED_TABS.slice(2, ASSOCIATED_ITEMS.ASSOCIATED_TABS.length),
          )
          setHeaderLabel('Widget')
          listDetail = {
            redirectViewAPiRouteMidPoint: PAGES_ROUTES.SiteNavigation,
            entityType: module,
            displayName: module,
          }
          break
        case CONSTANTS.ASSOCIATED_MODULE_CONTAINER:
          result = await dispatch(getContainerDetailById({ id, containerId: id }) as any)
          setTabs(
            ASSOCIATED_ITEMS.ASSOCIATED_TABS.slice(1, ASSOCIATED_ITEMS.ASSOCIATED_TABS.length),
          )
          setHeaderLabel('Container')
          listDetail = {
            redirectViewAPiRouteMidPoint: PAGES_ROUTES.ManageWidget,
            entityType: 'widget',
            displayName: 'widget',
          }
          break

        default:
          break
      }

      setDetailData(result?.payload?.data)
      setListingProperty(listDetail)
    }
  }

  const getFilterOptions = (
    id: 'type' | 'layout' | 'state',
    lable: string,
    options: any,
    searchable = true,
  ) => {
    return {
      id,
      lable,
      searchable,
      clearall: true,
      options,
    }
  }

  const getLayoutAndState = async () => {
    const result = await dispatch(getMasterByKey('keyName=STATES') as any)
    let requestedData: any
    let initialResult: any
    switch (selectedTabs.key) {
      case 'widget': {
        requestedData = WIDGET_MANAGEMENT_CRUD.LAYOUT.LIST('excludeSiteNavigationLayouts=true')
        initialResult = await mainApiService(requestedData)
        setListFilter([
          getFilterOptions(
            'type',
            ASSOCIATED_ITEMS.LISTING.FILTERS.TYPE,
            initialResult?.data?.Types,
          ),
          getFilterOptions(
            'layout',
            ASSOCIATED_ITEMS.LISTING.FILTERS.LAYOUT,
            initialResult?.data?.Layouts,
          ),
          getFilterOptions('state', ASSOCIATED_ITEMS.LISTING.FILTERS.STATE, result?.payload?.data),
        ])
        break
      }
      case 'container': {
        requestedData = CONTAINER_MANAGEMENT_CRUD.LAYOUT.LIST('')
        initialResult = await mainApiService(requestedData)
        setListFilter([
          getFilterOptions(
            'layout',
            ASSOCIATED_ITEMS.LISTING.FILTERS.LAYOUT,
            initialResult?.data?.Layouts,
          ),
          getFilterOptions('state', ASSOCIATED_ITEMS.LISTING.FILTERS.STATE, result?.payload?.data),
        ])
        break
      }
      case 'siteNavigation': {
        requestedData = SITE_NAVIGATION_CRUD.LAYOUTS_LISTING('type=Menu Items')
        const assetLayoutsData = await mainApiService(requestedData)
        if (assetLayoutsData?.data?.records?.length > 0) {
          initialResult = {
            data: {
              Layouts: assetLayoutsData.data.records.map((type: any) => ({
                key: type.layout,
                value: type.layout,
              })),
            },
          }
        }
        setListFilter([
          getFilterOptions(
            'layout',
            ASSOCIATED_ITEMS.LISTING.FILTERS.LAYOUT,
            initialResult?.data?.Layouts,
          ),
          getFilterOptions(
            'state',
            ASSOCIATED_ITEMS.LISTING.FILTERS.STATE,
            result?.payload?.data,
            false,
          ),
        ])
        break
      }
      default: {
        break
      }
    }
  }

  const handleOnNavigation = (pageData: any) => {
    navigate(-1)
  }

  const handleTabSelection = (e: MouseEvent<HTMLDivElement>, tab: IKeyValue) => {
    e.preventDefault()
    setSelectedTabs(tab)
  }

  const displayTabs = () => {
    if (tabs?.length > 0) {
      return tabs.map((tab) => {
        const isSelectedTab = tab.key === selectedTabs?.key
        return (
          <div
            className='font-semibold'
            key={toCamelCase(tab.key)}
            aria-hidden='true'
            onClick={(e) => handleTabSelection(e, tab)}
            style={{
              padding: '0.75rem 1.5rem',
              color: isSelectedTab ? '#402080' : '#3E3F40',
              background: isSelectedTab ? '#ECE9F2' : 'transparent',
              borderRadius: isSelectedTab ? '0.25rem 0.25rem 0 0' : 0,
              borderBottom: isSelectedTab ? '2px solid #402080' : 0,
              cursor: 'pointer',
            }}
          >
            {tab.value}
          </div>
        )
      })
    }
  }

  const getWidgetListFunction = async (options: any) => {
    let moduleDataName = `${module?.toLowerCase()}Id`
    let modulePayloadName = module
    if (module === CONSTANTS.ASSOCIATED_MODULE_SITENAVIGATION) {
      modulePayloadName = 'siteNavigation'
      moduleDataName = 'siteNavigationId'
    }
    const payload: any = {
      filters: options.filters,
      sortType: options.sortType ? options.sortType : -1,
      page: options.page ? options.page : 1,
      limit: options.limit ? options.limit : 10,
      associationInfo: {
        module: modulePayloadName,
        contentId: detailData?.[moduleDataName]?.toString(),
        tab: selectedTabs.key,
      },
    }
    if (options.sortBy) {
      payload.sortBy = options.sortBy
    }
    if (options.filterValue) {
      payload.searchText = options.filterValue
    }
    if (selectedTabs.key === MODULE_CONSTANTS.CONTAINER) {
      const parameterName = CONSTANTS.ASSOCIATED_CONTAINER_LISTING_COLUMNS.map(
        (data: any) => data.id,
      )
      payload.selectedParameters = [...parameterName, 'contentListingPage']
    }
    setIsLoader(true)

    let requestedData: any = {}
    if (module === 'parameter-repository') {
      delete payload.filters
      delete payload.associationInfo.module
      delete payload.associationInfo.contentId
      payload.associationInfo.parameterId = detailData?._id
      requestedData = ASSOCIATED_LIST.ASSOCIATED_PARAMETER_LISTING(payload)
    } else {
      requestedData = ASSOCIATED_LIST.LISTING(payload)
    }
    const result: any = await mainApiService(requestedData)
    const { responseCode } = handleResponse(result)
    if (result?.responseCode === 200) {
      const tempData: any[] = []
      switch (selectedTabs.key) {
        case 'widget':
          result?.data?.records?.forEach((ele: any) => {
            tempData.push({
              _id: ele?._id,
              widgetId: ele?.widgetId,
              title: ele?.title,
              type: ele?.type,
              widgetTypeTitle: ele?.widgetTypeTitle,
              layout: ele?.layout,
              engine:
                ele?.engine === 'NA'
                  ? ele?.engine
                  : ele?.engine?.charAt(0)?.toUpperCase() + ele?.engine?.slice(1)?.toLowerCase(),
              segment: ele?.segment,
              createdAt: getDateInFormat(ele?.createdAt ?? '', CONSTANTS.DATE_FORMAT_TIME_SECONDS),
              updatedAt: getDateInFormat(ele?.updatedAt ?? '', CONSTANTS.DATE_FORMAT_TIME_SECONDS),
              lastFeaturedDate: getDateInFormat(
                ele?.lastFeaturedDate ?? '',
                CONSTANTS.DATE_FORMAT_TIME_SECONDS,
              ),
              state: <AssetStateLabel state={ele?.stateDisplayName} />,
              status: (
                <Typography
                  className={`${style.status} ${
                    ele?.status === 'ACTIVE' ? style?.active : style?.inactive
                  }`}
                >
                  {ele.status === 'ACTIVE' ? 'Active' : 'In Active'}
                </Typography>
              ),
              versionCount: ele?.versionCount,
              rowURL: `/${listingProperty.redirectViewAPiRouteMidPoint}/${PAGES_ROUTES.PageTypeView}/${ele._id}`,
            })
          })
          break

        case 'container':
          result?.data?.records?.forEach((ele: any) => {
            tempData.push({
              _id: ele?._id,
              containerId: ele?.containerId,
              title: ele?.title,
              type: ele?.type,
              containerTypeTitle: ele?.containerTypeTitle,
              layout: ele?.layout,
              segment: ele?.segment,
              language: ele?.language,
              createdAt: getDateInFormat(ele?.createdAt ?? '', CONSTANTS.DATE_FORMAT_TIME_SECONDS),
              updatedAt: getDateInFormat(ele?.updatedAt ?? '', CONSTANTS.DATE_FORMAT_TIME_SECONDS),
              lastFeaturedDate: getDateInFormat(
                ele.lastFeaturedDate ?? '',
                CONSTANTS.DATE_FORMAT_TIME_SECONDS,
              ),
              state: <AssetStateLabel state={ele.stateDisplayName} />,
              versionCount: ele?.versionCount,
              isChildPageRequired: ele?.isChildPageRequired,
              isVersionRequired: ele?.isVersionRequired,
              isCloneRequired: ele?.isCloneRequired,
              contentListingPage: ele?.contentListingPage,
              status: (
                <Typography
                  className={`${style.status} ${
                    ele?.status === 'ACTIVE' ? style?.active : style?.inactive
                  }`}
                >
                  {ele.status === 'ACTIVE' ? 'Active' : 'In Active'}
                </Typography>
              ),
              rowURL: `/${listingProperty.redirectViewAPiRouteMidPoint}/${PAGES_ROUTES.PageTypeView}/${ele._id}`,
            })
          })
          break

        case 'siteNavigation':
          result?.data?.records?.forEach((ele: any) => {
            tempData.push({
              _id: ele?._id,
              siteNavigationId: ele?.siteNavigationId,
              title: ele?.title,
              type: ele?.type,
              layout: ele?.layout,
              segment: ele?.segment,
              createdAt: getDateInFormat(ele?.createdAt ?? '', CONSTANTS.DATE_FORMAT_TIME_SECONDS),
              updatedAt: getDateInFormat(ele?.updatedAt ?? '', CONSTANTS.DATE_FORMAT_TIME_SECONDS),
              lastFeaturedDate: getDateInFormat(
                ele.lastFeaturedDate ?? '',
                CONSTANTS.DATE_FORMAT_TIME_SECONDS,
              ),
              state: <AssetStateLabel state={ele?.stateDisplayName} />,
              versionCount: ele?.versionCount,
              status: (
                <Typography
                  className={`${style.status} ${
                    ele?.status === 'ACTIVE' ? style?.active : style?.inactive
                  }`}
                >
                  {ele.status === 'ACTIVE' ? 'Active' : 'In Active'}
                </Typography>
              ),
              widgetTypeTitle: ele?.widgetTypeTitle,
              rowURL: `/${listingProperty.redirectViewAPiRouteMidPoint}/${PAGES_ROUTES.PageTypeView}/${ele._id}`,
            })
          })

          break

        default:
          break
      }

      setDataCount(result?.data?.count)

      setListData(tempData)
      setIsLoader(false)
    } else if (responseCode === 404) {
      setDataCount(0)
      setListData([])
      setIsLoader(false)
    } else {
      dispatch(showAlert([true, combineErrorMessage(result), 'error']))
      setIsLoader(false)
    }
  }

  const handleOnRowClick = (event: any) => {
    if (selectedTabs.key === MODULE_CONSTANTS.CONTAINER) {
      dispatch(setParentContainerDetail({ containerId: event?._id ?? '', data: event }))
    }
  }

  const getHeaderComponent = () => {
    switch (module) {
      case 'segment':
        return (
          <HeaderComponent
            headerData={getHeaderData(detailData, module)}
            dynamicHeaderFirstRow={[
              {
                title: `${headerLabel} Name`,
                value: detailData?.segmentName || 'NA',
                maxCount: 25,
              },
              {
                title: 'Segment Description',
                value: detailData?.description || 'NA',
                maxCount: 100,
                toolTipWidth: '350px',
              },
            ]}
          />
        )

      case 'parameter-repository':
        return (
          <HeaderComponent
            headerData={getHeaderData(detailData, module)}
            dynamicHeaderFirstRow={[
              {
                title: 'Parameter Name',
                value: detailData?.parameterName || 'NA',
              },
              { title: 'Data Type', value: detailData?.dataType || 'NA' },
              {
                title: 'Field Type',
                value: detailData?.fieldType || 'NA',
              },
            ]}
          />
        )

      default:
        return (
          <HeaderComponent
            headerLabel={headerLabel}
            status={detailData?.stateDisplayName}
            type={detailData?.type}
            layout={detailData?.layout}
            title={detailData?.title}
            headerData={getHeaderData(detailData, module)}
          />
        )
    }
  }

  useEffect(() => {
    if (Object.keys(detailData).length > 0 && selectedTabs.key) {
      getWidgetListFunction(searchFunctionFilters)
      setListingApiCall(false)
    }
  }, [searchFunctionFilters])

  return (
    <div style={{ padding: '1rem 1.875rem', height: '100vh' }}>
      <div className={styles['breadcrums']} style={{ marginBottom: '0.75rem' }}>
        <Breadcrums
          isMarginTop={false}
          breadcrums={BREADCRUMS.ASSOCIATED_ITEMS(getPageName(module)) as any}
        />
      </div>
      <div className={styles['back-btn']}>
        <BackButton
          label={ASSOCIATED_ITEMS.LINK_CTA}
          className='col73'
          handleOnClick={() => handleOnNavigation(getPageName(module))}
        />
      </div>
      <div className={styles['background']}>
        <div className='w-100' style={{ marginBottom: '1.5rem' }}>
          {getHeaderComponent()}
        </div>
      </div>
      <div className='w-100'>
        <div className='d-flex' style={{ gap: '1rem', backgroundColor: 'white' }}>
          {displayTabs()}
        </div>

        <ListingComponent
          columns={columnData}
          tableRows={listData}
          dataCount={dataCount}
          isLoading={isLoader}
          searchPlaceholder={
            module === 'parameter-repository'
              ? ASSOCIATED_ITEMS.LISTING.SEARCH_PLACE_HOLDER_FOR_PARAMETER
              : ASSOCIATED_ITEMS.LISTING.SEARCH_PLACE_HOLDER
          }
          headerAddon
          handleClearAllFilters={() => {
            setSearchFunctionFilters((pre) => ({
              ...pre,
              filters: [],
              page: 1,
            }))
            dispatch(showAlert([true, 'All filters cleared', 'success']))
          }}
          showCreateButton={false}
          noDataPlaceHolder={`No ${listingProperty.displayName} is associated`}
          showAdvanceFilter={true}
          clearFilterValues={clearColumnFilter}
          filterValuesCleared={(value: boolean) => setClearColumnFilter(!value)}
          searchFunction={(search, sorttype, coltype, filters, pagenumber, pagecount) => {
            if (Object.keys(detailData).length > 0 && selectedTabs.key) {
              setSearchFunctionFilters((pre) => ({
                ...pre,
                filters: filters,
                sortBy: coltype,
                sortType: sorttype,
                page: pagenumber,
                limit: pagecount,
                filterValue: search,
              }))
            }
          }}
          searchBarSize='large'
          isAssociatedList={true}
          handleRowClick={(event) => handleOnRowClick(event)}
          paginationOption={CONSTANTS.PAGINATION_OPTIONS}
          showFilterOptions={headerLabel !== 'Parameter'}
          showVersionColumn={module !== 'parameter-repository'}
          searchLabel='Search'
          showSearchIcon={false}
          entityType={listingProperty?.entityType}
          filterFields={listFilter}
          shouldSearchFunctionCall={listingApiCall}
        />
      </div>
    </div>
  )
}

export default AssociatedItems
